export const HOME_PAGE_SETTING = "HOME_PAGE_SETTING";
export const SETTING = "SETTING";
export const PRIVACY_DATA = "PRIVACY_DATA";
export const CANCELL_POLICY = "CANCELL_POLICY";
export const ABOUT_US = "ABOUT_US";
export const TERMS_DATA = "TERMS_DATA";
export const RAISE_QUERY = "RAISE_QUERY";
export const GOLFCLIX_COUNTRY = "GOLFCLIX_COUNTRY";
